import { createAsyncAction } from "./utils"; // *** Sign in

export var sendPasswordResetEmail = createAsyncAction('sendPasswordResetEmail', function (email, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.sendPasswordResetEmail(email, opts.IdentitySDK.PASSWORD_RESET_URLS.MY_NERDWALLET, serverRequest);
    }
  };
});
export var verifyEmail = createAsyncAction('verifyEmail', function (emailVerificationToken, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.verify(emailVerificationToken, serverRequest);
    }
  };
});
export var resendVerificationEmail = createAsyncAction('resendVerificationEmail', function (serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.resendVerificationEmail(opts.IdentitySDK.EMAIL_VERIFICATION_URLS.MY_NERDWALLET, serverRequest);
    }
  };
});
export var resendSweepVerificationEmail = createAsyncAction('resendSweepVerificationEmail', function (serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.resendVerificationEmail(opts.IdentitySDK.EMAIL_VERIFICATION_URLS.SWEEP, serverRequest);
    }
  };
});
export var updateEmail = createAsyncAction('updateEmail', function (password, newEmail, config, serverRequest) {
  return {
    meta: {
      newEmail: newEmail
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.updateEmail(password, newEmail, serverRequest, config);
    }
  };
});